import React from "react";
import { Card, CardBody, Col, Row, CardHeader, Container, Input } from "reactstrap";
import UiContent from "../../../Components/Common/UiContent";

import BreadCrumb from "../../../Components/Common/BreadCrumb";

import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";

const FormEditor = () => {
  const {  quillRef } = useQuill();

document.title ="Editors | Velzon - React Admin & Dashboard Template";
  return (
    <React.Fragment>
      <UiContent />
      <div className="page-content">
        
        <Container fluid>
          <BreadCrumb title="Editors" pageTitle="Forms" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="align-items-center d-flex">
                  <h4 className="card-title mb-0">Rich text (demo)</h4>
                </CardHeader>
                <CardBody>
                  <Input
                    type="textarea"
                    rows={6}
                    defaultValue="Hello from Velzon demo editor."
                    readOnly
                    className="text-muted"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row className="mt-2">
            <Col lg={12}>
              <div className="justify-content-between d-flex align-items-center mb-3">
                <h5 className="mb-0 pb-1 text-decoration-underline">
                  Quilljs Editor
                </h5>
              </div>
              <Card>
                <CardHeader>
                  <h4 className="card-title mb-0">Snow Editor</h4>
                </CardHeader>
                <CardBody>                  
                  <div className="snow-editor" style={{ height: 300 }}>
                    <div ref={quillRef} />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FormEditor;
